import React, {useState} from "react"
import styled from "styled-components"
import {Emoji} from "emoji-mart"

import {Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import padding from "@irati/ui/src/global/padding"
import theme from "@irati/ui/src/global/theme"

const Wrapper = styled.div`
  margin-top: ${padding.small};
`

const MaxWidth = styled.div`
  max-width: 350px;
`

const StyledEmoji = styled.span`
  .emoji-mart-emoji {
    margin: 0 5px;
    top: 5px;
  }
`

interface Props {
  onClick: () => void
}

const MakeAClaim: React.FC<Props> = (props) => {
  const [isClicked, setIsClicked] = useState(false)
  const {onClick} = props

  const handleClick = () => {
    setIsClicked(true)
    onClick()
  }

    return isClicked ? (
      <Wrapper>
        <Card>
          <MaxWidth>
            <Body marginBottom={1} display="inline" weight="light">
              <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.start" />
            </Body>
            <StyledEmoji>
              <Emoji emoji={{id: "iphone"}} size={20} set="apple" />
            </StyledEmoji>
            <Body marginBottom={1} display="inline" color={theme.colors.perkbox.blue}>
              <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.phoneNumber" />
            </Body>
            <Wrapper>
              <Body small marginBottom={1}>
                <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.para" />
                <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.download" />
              </Body>
            </Wrapper>
          </MaxWidth>
        </Card>
      </Wrapper>
    ) : (
      <Wrapper>
        <Button primary large full onClick={handleClick}>
          <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.button" />
        </Button>
      </Wrapper>
    )
}

export default MakeAClaim
